import React from 'react';
import { ClipboardCheck, Heart, TrendingUp, MessageCircle } from 'lucide-react';
import { whyUs } from '../data/mock';

const iconMap = {
  ClipboardCheck,
  Heart,
  TrendingUp,
  MessageCircle
};

const WhyUs = () => {
  return (
    <section id="neden-biz" className="py-20 lg:py-32 bg-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-600 via-red-500 to-red-600" />
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-red-600/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-red-600/20 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-red-500 font-semibold text-sm uppercase tracking-wider">Neden Nova?</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-3 mb-6">
            Farkımız Sonuçlarımızda
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Yıllarca biriktirdiğimiz deneyim ve modern eğitim anlayışımızla öğrencilerimizin yanındayız.
          </p>
        </div>

        {/* Why Us Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {whyUs.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.id}
                className="group relative bg-white/5 backdrop-blur-sm hover:bg-white/10 rounded-2xl p-8 transition-all duration-300 border border-white/10 hover:border-red-500/30"
              >
                <div className="flex items-start gap-6">
                  {/* Icon */}
                  <div className="flex-shrink-0 w-16 h-16 bg-red-600/20 group-hover:bg-red-600 rounded-xl flex items-center justify-center transition-all duration-300">
                    <Icon className="w-8 h-8 text-red-500 group-hover:text-white transition-colors" />
                  </div>

                  {/* Content */}
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* Number Badge */}
                <div className="absolute top-4 right-4 w-8 h-8 bg-red-600/20 rounded-full flex items-center justify-center">
                  <span className="text-red-500 font-bold text-sm">0{index + 1}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
